import React, { useEffect, useState, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import { connect } from 'react-redux';
import ecStat from 'echarts-stat';
import moment from 'moment';
import { Tag } from 'antd';
import ReactEcharts from '../../Echarts/Echarts';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { config } from '../../constant';
import { regressionMockJson } from '../../../Mock/MockJson';
import { Fragment } from 'react';

const Regression = (props) => {

  const [option, setOption] = useState(getOption(props));
  const [refreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);


  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const getData = async () => {
    requestCheck.current = false;
    let theme = props.selectedThemeing;
    let legend = [];
    let json = [];
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = regressionMockJson;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    //  json = [
    //     [1, 4862.4],
    //     [2, 5294.7],
    //     [3, 5934.5],
    //     [4, 7171.0],
    //     [5, 8964.4],
    //     [6, 10202.2],
    //     [7, 11962.5],
    //     [8, 14928.3],
    //     [9, 16909.2],
    //     [10, 18547.9],
    //     [11, 21617.8],
    //     [12, 26638.1],
    //     [13, 34634.4],
    //     [14, 46759.4],
    //     [15, 58478.1],
    //     [16, 67884.6],
    //     [17, 74462.6],
    //     [18, 1200.7]
    // ];

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      if (json && Array.isArray(json)) {
        var myRegression = ecStat.regression('exponential', json);

        myRegression.points.sort(function (a, b) {
          return a[0] - b[0];
        });

        let series = [
          {
            name: 'scatter',
            type: 'scatter',
            emphasis: {
              label: {
                show: true,
                position: 'left',
                color: theme === 'lightTheme' ? 'black' : 'white',
                fontSize: 16
              }
            },
            data: json
          },
          {
            name: 'line',
            type: 'line',
            showSymbol: false,
            smooth: true,
            data: myRegression.points,
            markPoint: {
              itemStyle: {
                color: 'transparent'
              },
              label: {
                show: true,
                position: 'left',
                formatter: myRegression.expression,
                color: '#333',
                fontSize: 14
              },
              data: [
                {
                  coord: myRegression.points[myRegression.points.length - 1]
                }
              ]
            }
          }
        ];

        legend.push({
          name: 'scatter'
        });
        legend.push({
          name: 'line'
        });

        series = await trendLabelTranslation(series, props.translationCache);
        legend = await trendLabelTranslation(legend, props.translationCache);

        const option = cloneDeep(getOption());
        option.series = series;
        option.legend = {
          textStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
            fontSize: 18,
            fontWeight: 'bold'
          },
          right: 60,
          data: [...legend]
        };
        setOption(option);
      }
    }

    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  function getOption() {
    let theme = props.selectedThemeing;
    let option = {
      legend: {
        textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      xAxis: {
        type: 'value',
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        },
        splitNumber: 20
      },
      yAxis: {
        type: 'value',
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        }
      }
    };
    return option;
  }

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.translationCache
  };
};


export default connect(mapStateToProps)(Regression);
